import React, { useState, useEffect } from 'react'
import moment from 'moment'
import GroupIcon from '@mui/icons-material/Group';
import StartTickicon from '../Images/StartTickIcon.png'
import Loot from '../Images/Loot.png'
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Sector, Cell, BarChart, Bar } from 'recharts';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { CheckFunction } from '../../../../../../layouts/MainTenantconfig';
import { GetCommunityDashboardDataById,getConversionOvertimebyId, getTopPerfomanceVehicleDetailById,getCONTRIBUTIONGarphForDealerById } from '../CommunityActionCreator';

const data = [
    {
        name: 'Page A',
        uv: 4000,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        amt: 2000,
    },

];

const Piedata = [
    { name: 'Group A', value: 400 },
    { name: 'Group B', value: 300 },
];

const bardata = [
    {
        name: 'Page A',
        uv: 4000,
        amt: 2400,
    },
    {
        name: 'Page B',
        uv: 3000,
        amt: 2210,
    },
    {
        name: 'Page C',
        uv: 2000,
        amt: 2290,
    },
    {
        name: 'Page D',
        uv: 2780,
        amt: 2000,
    },

];

const COLORS = ['#FF8158', '#01647F'];

export default function CommunityDetailDashboardnew({ communityId, handlePage }) {
    const tenant = CheckFunction()
    const [payload, setPayload] = useState({
        fromDate: moment(new Date).format("YYYY-MM-DD"),
        toDate: moment(new Date).format("YYYY-MM-DD")
    })
    const [listData,setListData] =useState({})
    const [conversionTrendData,setconversionTrendData] =useState([])
    const [performingVehicleData,setperformingVehicleData] =useState([])
    const [AgentData,setAgentData] =useState({})

    const handleChange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const handleApply = () => {
        GetCommunityDashboardDataByIdFn(payload)
        getConversionOvertimebyIdFn(payload)
        getTopPerfomanceVehicleDetailByIdFn(payload)
        getCONTRIBUTIONGarphForDealerByIdFn(payload)
    }

    useEffect(()=>{
        GetCommunityDashboardDataByIdFn(payload)
        getConversionOvertimebyIdFn(payload)
        getTopPerfomanceVehicleDetailByIdFn(payload)
        getCONTRIBUTIONGarphForDealerByIdFn(payload)
    },[])

    const GetCommunityDashboardDataByIdFn = (data) =>{
        const d ={
            communityId:communityId,
            sDate: moment(data.fromDate).format("DD-MM-YYYY"),
            eDate: moment(data.toDate).format("DD-MM-YYYY")
        }
        GetCommunityDashboardDataById(d,callback=>{
            console.log(callback)
            if(callback && callback?.message == "success"){
                setListData(callback?.data)
            }else{
                setListData({})
            }
        })
    }
    const getConversionOvertimebyIdFn = (data) =>{
        const d ={
            communityId:communityId,
            sDate: moment(data.fromDate).format("DD-MM-YYYY"),
            eDate: moment(data.toDate).format("DD-MM-YYYY")
        }
        getConversionOvertimebyId(d,callback=>{
            console.log(callback)
            if(callback && callback?.message == "success"){
                setconversionTrendData(callback?.data)
            }else{
                setconversionTrendData([])
            }
        })
    }
    const getTopPerfomanceVehicleDetailByIdFn = (data) =>{
        const d ={
            communityId:communityId,
            sDate: moment(data.fromDate).format("DD-MM-YYYY"),
            eDate: moment(data.toDate).format("DD-MM-YYYY")
        }
        getTopPerfomanceVehicleDetailById(d,callback=>{
            console.log(callback)
            if(callback && callback?.message == "success"){
                setperformingVehicleData(callback?.data)
            }else{
                setperformingVehicleData([])
            }
        })
    }
    const getCONTRIBUTIONGarphForDealerByIdFn = (data) =>{
        const d ={
            communityId:communityId,
            sDate: moment(data.fromDate).format("DD-MM-YYYY"),
            eDate: moment(data.toDate).format("DD-MM-YYYY")
        }
        getCONTRIBUTIONGarphForDealerById(d,callback=>{
            console.log(callback)
            if(callback && callback?.message == "success"){
                const arr = [
                    {
                        name:"Sales Contribution",
                        value:callback?.data?.salesContributionPercent
                    },
                    {
                        name:`${tenant?.COMPANY_NAME} Contribution`,
                        value:callback?.data?.amuContributionPercent
                    },
                ]
                setAgentData(arr)
            }else{
                setAgentData({})
            }
        })
    }


    return (
        <>
            <div className="row">
                <div className="col-sm-2 col-xs-6">
                    <label htmlFor="">Start Date</label>
                    <input type='date' value={payload?.fromDate} className='form-control' onChange={(e) => handleChange(e, "fromDate")} />
                </div>
                <div className="col-sm-2 col-xs-6">
                    <label htmlFor="">End Date</label>
                    <input type='date' value={payload?.toDate} className='form-control' onChange={(e) => handleChange(e, "toDate")} />
                </div>
                <div className="col-sm-2 col-xs-6">
                    <button className='btn btn-primary' onClick={() => handleApply()} style={{ marginTop: '22px', padding: '10px' }}>Filter</button>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-8 col-xs-12">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <CommonTabs heading={"Total Applications Received"} value={listData?.communityStats?.assigned} backgroundColor={"#579a1d33"} iconName={"GroupIcon"} />
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <CommonTabs heading={"Applications Approved"} value={listData?.communityStats?.leadApproved} backgroundColor={"#b3b2e099"} iconName={"StartTickicon"} />
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <CommonTabs heading={"Disbursed Loans  (count )"} value={listData?.communityStats?.leadDisbursed} backgroundColor={"#5b93ff4d"} iconName={"Loot"} />
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <CommonTabs heading={"Conversion Rate"} value={listData?.communityStats?.conversionRate} backgroundColor={"#fdd44033"} iconName={"LeaderboardIcon"} />
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <CommonTabs heading={"Pending Applications"} value={listData?.communityStats?.leadPending} backgroundColor={"#e5024e33"} iconName={"WatchLaterRoundedIcon"} />
                        </div>
                        <div className="col-lg-4 col-md-6 col-xs-12">
                            <CommonTabs heading={"Disbursed Loans ( Value )"} value={listData?.communityStats?.leadDisbursedValue} backgroundColor={"#5b93ff4d"} iconName={"Loot"} />
                        </div>
                        <div className="col-xs-12">
                            <div style={{ ...tabsStyle, display: 'block', height: 'auto',marginTop:"30px" }}>
                                <h4><b>Conversion Trend Over Time</b></h4>
                                <hr style={{ margin: '20px 0 10px 0' }} />
                                <div className="chart" style={{ height: '300px' }}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart
                                            width={500}
                                            height={300}
                                            data={conversionTrendData}
                                            margin={{
                                                top: 20,
                                                right: 20,
                                                left: 20,
                                                bottom: 0,
                                            }}
                                        >
                                            <CartesianGrid vertical={false} horizontal={true} stroke='#e4e4e4' />
                                            <XAxis dataKey="value" tickLine={false} axisLine={false} />
                                            <YAxis tickLine={false} axisLine={false} />
                                            <Tooltip />
                                            <Line dataKey="data" stroke="#01647F" strokeWidth={"1.5"} dot={{
                                                r: 5,
                                                stroke: '#FF8158',
                                                strokeWidth: 4,
                                                fill: '#fff',
                                            }} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-xs-12">
                            <div style={{ ...tabsStyle, display: 'block', height: 'auto',marginTop:"30px" }}>
                                <h4><b>Agent Contribution By Type</b></h4>
                                <hr style={{ margin: '20px 0 10px 0' }} />
                                <div className="chart" style={{ height: '300px' }}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <PieChart width={400} height={400}>
                                            <Pie
                                                data={AgentData}
                                                cx="50%"
                                                cy="50%"
                                                labelLine={false}
                                                label={renderCustomizedLabel}
                                                outerRadius={120}
                                                fill="#8884d8"
                                                dataKey="value"
                                            >
                                                {Piedata.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                ))}
                                            </Pie>
                                        </PieChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xs-12">
                            <div style={{ ...tabsStyle, display: 'block', height: 'auto',marginTop:"30px" }}>
                                <h4><b>Top Performing Vehicles</b></h4>
                                <hr style={{ margin: '20px 0 10px 0' }} />
                                <div className="chart" style={{ height: '300px' }}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <BarChart width={150} height={40} data={performingVehicleData}
                                            barSize={30}
                                            margin={{
                                                top: 10,
                                                right: 10,
                                                left: -10,
                                                bottom: 0,
                                            }}>
                                            <CartesianGrid horizontal={true} vertical={false} stroke='#e4e4e4' />
                                            <XAxis dataKey="make" tickLine={false} axisLine={false} />
                                            <YAxis tickLine={false} axisLine={false} />
                                            <Tooltip />
                                            <Bar dataKey="vehicleCount" fill="#6FA6B5" radius={[5, 5, 5, 5]} />
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-sm-4 col-xs-12">
                    <div style={{ ...tabsStyle, display: 'block', height: 'auto', textAlign: "center",marginTop:"30px" }}>

                        <AccountCircleIcon style={{ width: '35%', height: '35%', color: 'grey' }} />
                        <h3 className='text-center' style={{ margin: "10px 0", fontWeight: '500' }}>{listData?.communityName || ""}</h3>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Dealer ID:</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>{listData?.communityCode || ""}</h5>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Region / Zone :</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>{listData?.communityCity+ "/" + listData?.communityState}</h5>
                        </div>
                        {/* <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Onboard Date:</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>22 Feb. 2022</h5>
                        </div> */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Type:</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>{listData?.communityType || ""}</h5>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Number Of Hired Aents :</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>{listData?.noOfHiredAgent || "0"}</h5>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Number Of {tenant?.COMPANY_NAME} Agents Assigned :</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>{listData?.noOfAmuAgent || "0"}</h5>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', margin: "0 8%" }}>
                            <h5 style={{ fontSize: '15px', textAlign: 'left' }}><b>Last Login / Activity :</b></h5>
                            <h5 style={{ fontSize: '15px', color: '#0000005E', textAlign: 'right' }}>{listData?.lastLogin || ""}</h5>
                        </div>

                    </div>
                    <div style={{ ...tabsStyle, display: 'block', height: 'auto', marginTop: "30px" }}>
                        <h4 style={{marginBottom:'20px'}}><b>Dealers Own Agent vs {tenant?.COMPANY_NAME} Agent</b></h4>
                        <div className='overflow-auto'>
                            <table className='phocket-table'>
                                <thead style={{ backgroundColor: '#223d64' }}>
                                    <tr>

                                        <th>Metrics</th>
                                        <th>Dealer Agent</th>
                                        <th>{tenant?.COMPANY_NAME} Agent</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Leads Assigned</td>
                                        <td>{listData?.salesAgentStatsCount?.assigned}</td>
                                        <td>{listData?.amuAgentStatsCount?.assigned}</td>
                                    </tr>
                                    <tr>
                                        <td>Leads Converted</td>
                                        <td>{listData?.salesAgentStatsCount?.converted}</td>
                                        <td>{listData?.amuAgentStatsCount?.converted}</td>
                                    </tr>
                                    <tr>
                                        <td>Conversion Rate</td>
                                        <td>{listData?.salesAgentStatsCount?.conversionRate + "%"}</td>
                                        <td>{listData?.amuAgentStatsCount?.conversionRate + "%"}</td>
                                    </tr>
                                    {/* <tr>
                                        <td>Follow-ups Missed</td>
                                        <td>10</td>
                                        <td>5</td>
                                    </tr>
                                    <tr>
                                        <td>Revenue Generated</td>
                                        <td>₹35L</td>
                                        <td>₹15L</td>
                                    </tr> */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div style={{ ...tabsStyle, display: 'block', height: '450px', marginTop: '30px' }}>
                        <h5 style={{ marginTop: '0' }}><b>Regional Disbursal Density</b></h5>
                        <hr style={{ margin: '10px 0' }} />
                    </div>
                </div>
            </div >
        </>
    )
}


const CommonTabs = ({ heading, value, backgroundColor, iconName }) => {
    return (
        <>
            <div style={{...tabsStyle,marginTop:"30px"}}>
                <div style={{ ...circleStyle, background: backgroundColor }}>
                    {
                        iconName == "GroupIcon" ?
                            <GroupIcon style={{ fontSize: '24px', color: '#579A1D' }} />
                            :
                            iconName == "LeaderboardIcon" ?
                                <LeaderboardIcon style={{ fontSize: '24px', color: '#FDD440' }} />
                                :
                                iconName == "WatchLaterRoundedIcon" ?
                                    <WatchLaterRoundedIcon style={{ fontSize: '24px', color: '#E5024E' }} />
                                    :
                                    iconName == "StartTickicon" ?
                                        <img src={StartTickicon} width={"100%"} />
                                        :
                                        iconName == "Loot" ?
                                            <img src={Loot} width={"100%"} />
                                            :
                                            ''}
                </div>
                <div style={{ marginLeft: '20px' }}>
                    <h3 style={{ fontSize: '36px', fontWeight: '400', color: '#000' }}>{value || "0"}</h3>
                    <h6 style={{ color: '#030229', fontSize: '18px', fontWeight: '400' }}>{heading}</h6>
                </div>
            </div>
        </>
    )
}


const circleStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    padding: "17px 15px",
    textAlign: 'center',
    flexShrink: 0,
}

const tabsStyle = {
    display: 'flex',
    alignItems: "center",
    marginTop: '20px',
    background: '#fff',
    padding: '20px',
    borderRadius: '6px',
    boxShadow: '3px 3px 10px 1px #eee',
    height: '145px'
}


const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, payload }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <>
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${payload.name}:`}
            </text>
            <text x={x} y={y + 20} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {` ${(percent * 100).toFixed(0)}%`}
            </text>
        </>
    );
};